import React from "react";
import { ContentCutOutlined, East, Person } from "@mui/icons-material";
import { Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import Service from "../../../util/Service";
const ITEM_HEIGHT = 48;
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function KanbanCardMembrosMenu(props) {
    const { action, kanban, cartao } = props;
    const [checked, setChecked] = React.useState([0]);
    const [membros, setMembros] = React.useState([]);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    React.useEffect(()=>{
        if( open === true && cartao){
            const arr=[];
            const arrM=[];
            if( cartao.membros ){
                for( let m of cartao.membros){
                    arr.push(m.login);
                    arrM.push(m);
                }
            }
            if( kanban.membros ){
                for( let m of kanban.membros){
                    const jaExiste = arrM.find( a => a.login === m.login);
                    if( jaExiste) continue;
                    arrM.push(m);
                }
            }
            setChecked(arr);
            setMembros(arrM);
            
        }
    },[open])
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];
    
        if (currentIndex === -1) {
          newChecked.push(value);
        } else {
          newChecked.splice(currentIndex, 1);
        }
        console.log(" IMPLEMENTAR TOGGLE MEMBRO  ", newChecked );
    
        setChecked(newChecked);

        const dado = {
            idCartao: cartao.id,
            toggle: newChecked
        }
        console.log( dado) ;

        Service.POST('/api/security/projeto/kanban/toggleMembro', dado).then(r => {
            console.log( r );
            if (action) action(dado);
            
        })
      };

    function handleMenuItem(row) {
        const dado = {
            id: cartao.id,
            idColuna: row.id
        }
        if (action) action(dado);
    }
    return (
        <React.Fragment>
            <MenuItem onClick={handleClick}>
                <ListItemIcon size='small'>
                    <Person fontSize="small" />
                </ListItemIcon>
                Alterar Membros
            </MenuItem>

            <Menu sx={{ width: 520, maxWidth: '100%' }}
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        style: {
                            maxHeight: ITEM_HEIGHT * 10.5,
                            width: '30ch',
                        },
                    },
                    list: {
                        'aria-labelledby': 'long-button',
                    },
                }}
                size='small'
            >
                {membros && membros.map((row, id) => {
                    return (
                        <ListItem
                            key={"mb-"+id}
                            disablePadding
                        >
                            <ListItemButton role={undefined} onClick={handleToggle(row.login)} dense>
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={checked.includes(row.login)}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText id={row.login} primary={row.nome} 
                                    secondary={
                                      <Typography
                                        component="span"
                                        variant="body2"
                                        sx={{ color: 'text.primary', display: 'inline' }}
                                      >
                                        {row.email}
                                      </Typography>
                                  }
                                />
                            </ListItemButton>
                        </ListItem>
                    )
                })}

            </Menu>
        </React.Fragment>
    )
}